export const API_URL = 'API_URL';

export const DEFAULT_DATE_FORMAT = "yyyy-MM-dd HH:mm:ss";
export const DEFAULT_DATE_NO_TIME_FORMAT = "yyyy-MM-dd";
export const DATE_WITH_HOUR_FORMAT = "yyyy-MM-dd H'h'";

export const EstandarDirecciones = Object.freeze({
  TIPO_VIA_PRINCIPAL: "TIPO_VIA_PRINCIPAL",
  VIA_PRINCIPAL_LITERAL: "VIA_PRINCIPAL_LITERAL",
  VIA_PRINCIPAL_BIS: "VIA_RINCIPAL_BIS",
  VIA_PRINCIPAL_BIS_LITERAL: "VIA_PRINCIPAL_BIS_LITERAL",
  VIA_PRINCIPAL_CARDINALIDAD: "VIA_PRINCIPAL_CARDINALIDAD",
  VIA_GENERADORA_LITERAL: "VIA_GENERADORA_LITERAL",
  VIA_GENERADORA_CARDINALIDAD: "VIA_GENERADORA_CARDINALIDAD",
  COMPLEMENTO: "COMPLEMENTO"
});
